import { Card, CardContent } from '@mui/material';
import React from 'react';
import * as S from './styles';

type MobileWarningCardProps = {};

const MobileWarningCard: React.FC<MobileWarningCardProps> = () => (
  <Card>
    <CardContent>
      <S.Text variant="h3">
        Daily data isn&apos;t available on screens this small. Please visit it
        on a larger screen to view complete data.
      </S.Text>
    </CardContent>
  </Card>
);
export default MobileWarningCard;
